"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateFromElement = require("./stateFromElement");

Object.keys(_stateFromElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _stateFromElement[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-import-html/~/draft-js-import-element/lib/main.js
// module id = 1200
// module chunks = 1